export const OPEN_INSTALL_APP_MODAL = 'OPEN_INSTALL_APP_MODAL';
export const CLOSE_INSTALL_APP_MODAL = 'CLOSE_INSTALL_APP_MODAL';
